import { IHorizontalMenuModel } from '@types-custom/models/ui/horizontal-menu.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ILeftMenu, ISideMenu } from './side-menu.model';
import { MapLayerMouseEvent, Marker } from 'mapbox-gl';
import { IDynamicSideMenuModel } from './dynamic-side-menu';
import { IDynamicFilterModel } from './dynamic-filter';
import { RightPanelMapType } from './right-panel-model';
import { IMapConventionsPropertiesModel } from './map-conventions-model';

// export interface IMapviewerDataSource {
//   getAPIList: (listType: any, isClearingCache: boolean) => Observable<any[]>;
// }

export abstract class AbstractMapviewerDataSource {
  abstract getAPIList(
    listType: any,
    isClearingCache: boolean,
    isAllDataLoaded: boolean
  ): Observable<any[]>;
}

export interface IMapViewerPropsModel<Events, Layers> {
  containerId: string;
  // Mappers
  layersDataMap: any;
  menuRightPanelMap: RightPanelMapType;
  markerModalMap: any;
  geoModalMap: any;
  mapEventsMap?: { [key: string]: IDynamicSideMenuModel };
  // DS
  dataSource: AbstractMapviewerDataSource;
  // LeftMenu
  leftMenuEvents$: Subject<Events | undefined>;
  leftMenuModelIcons: ISideMenu<Layers>[];
  leftMenuItems?: ISideMenu<Layers>[];
  logoText?: string;
  textInline?: BehaviorSubject<string> | Observable<string>;
  // Footer
  currentLayer$: BehaviorSubject<Layers | undefined>;
  footerDynamicEvents$: Subject<Events | undefined>;
  footerStaticEvents$: Subject<Events | undefined>;
  footerModel: IHorizontalMenuModel[];
  // Filters
  dynamicFiltersModel?: IDynamicFilterModel;
  // Conventions Component
  mapConventionsProps: IMapConventionsPropertiesModel | undefined;
  // Refresh Dispatcher
  refreshDispatcher?: Subject<any>;
  // Click interaction Dispatcher
  clickInteractionDispatcher?: BehaviorSubject<string>;
  isSideMenuVisible?: BehaviorSubject<boolean> | Observable<boolean>;
  mapFilter: any;
  mapIcons: any;
  markerRightPanelMap: any;
  autoUpdatedLayers: string[];
  fastAutoUpdatedLayers: string[];

  headerInfo?: any;
}

export interface IMapEvent {
  type: MapEventTypeEnum; //MapLayerEventType;
  event?: MapLayerMouseEvent;
  lng: number;
  lat: number;
  marker?: Marker;
}

export enum MapEventTypeEnum {
  CLICK = 'click',
  INCIDENTS = 'manage-incidents',
  NOTIFICATIONS = 'notifications',
  CAMERAS = 'manage-cameras',
  PMV = 'manage-pmv',
  SENSORS = 'manage-sensors',
  // PMV = 'manage-variable-messaging',
  ALERTS = 'manage-alerts',
  PMVconsulta = 'PMVconsulta',
  PMVEditar = 'PMVEditar',
}
